import {defineStore} from 'pinia';
import {ref} from 'vue';
import { useAuthStore } from '../stores/auth';
import Prompt  from '../types/Prompt';
import { CustomFieldCreateSelect$inboundSchema } from '@polar-sh/sdk/dist/commonjs/models/components/customfieldcreateselect';

export const useDrawingsStore = defineStore('drawings', () => {
    const apiUrl = process.env.VUE_APP_DJANGO_BACKEND;
    const authStore = useAuthStore();
    const loading = ref<boolean>(true);
    const drawings = ref<[]>([]);
    const error = ref<string | null>(null);

    const fetchDrawings = async (accessToken: string) => {
        if (accessToken) {
            try {
                const response = await fetch(`${apiUrl}/api/drawings/`,{
                    headers: { Authorization: `Bearer ${accessToken}`},
                });

                if (!response.ok) {
                    const errorMessage = `Error: ${response.status} ${response.statusText}`;
                    throw new Error(errorMessage);
                }
                drawings.value = await response.json();

            }catch (err) {
                error.value = err instanceof Error ? err.message: "An error occured";
            }finally{
                loading.value=false;
            }
        }
    }

    const saveDrawing = async (accessToken: string, payload:any) => {
        if (accessToken) {
            try {
                loading.value = true;
                const data = {
                      name: `coloring-${Date.now()}.jpg`,
                      image: payload.image
                  }

                console.log(data)

                const response = await fetch(`${apiUrl}/api/drawings/`,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                         Authorization: ` Bearer ${accessToken}`,
                    },
                    body: JSON.stringify(data)
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    error.value = errorData.detail || 'Request failed.';
                    return;
                }
            
                const responseData = await response.json();

            } catch (err) {
                error.value = err instanceof Error ? err.message: "An error occured"
            } finally {
                loading.value=false;
            }
        }
    }

    const deleteDrawing = async (accessToken: string, uuid:string) => {
        if (accessToken) {
            try {
                loading.value = true;
                const response = await fetch(`${apiUrl}/api/drawings/${uuid}/`,{
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                         Authorization: ` Bearer ${accessToken}`,
                    }
                })
                if (!response.ok) {
                    const errorData = await response.json();
                    error.value = errorData.detail || 'Request failed.';
                    return;
                }

            } catch (err) {
                error.value = err instanceof Error ? err.message: "An error occured"
            } finally {
                loading.value=false;
            }
        }
    }

    return { saveDrawing, fetchDrawings, deleteDrawing, drawings, loading, error}
})
